import { Link } from "react-router-dom";
import { Type } from "@shared/ui/Type";

type Props = {
  hideSignupLink?: boolean;
};

export function LoginAdditionalContent({ hideSignupLink = false }: Props) {
  return (
    <div className="flex flex-col items-center gap-4">
      {!hideSignupLink && (
        <Type variant="caption">
          Don't have an account?{" "}
          <Link
            to="/signup"
            className="underline hover:text-brand-600 transition-color duration-200"
          >
            Sign up
          </Link>
        </Type>
      )}
      <Type variant="caption">
        <Link
          to="/forgot-password"
          className="underline hover:text-brand-600 transition-color duration-200"
        >
          Forgot your password?
        </Link>
      </Type>
    </div>
  );
}

export default LoginAdditionalContent;
